import { render, staticRenderFns } from "./AddLocationModal.vue?vue&type=template&id=47d3a0a9&scoped=true&"
import script from "./AddLocationModal.vue?vue&type=script&lang=js&"
export * from "./AddLocationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddLocationModal.vue?vue&type=style&index=0&id=47d3a0a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d3a0a9",
  null
  
)

export default component.exports